module.exports = __webpack_public_path__ + "img/img_lowest-prices-overlay.4f775642.png";